<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="PointList"
          :extra-items="[
            '點數異動紀錄'
          ]" 
        />
      </div>
    </div>
    <b-card>
      <PointLog />
    </b-card>
  </div>
</template>

<script>
import PointLog from "@/components/Dashboard/PointLog/PointLog.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    PointLog,
    BreadCrumb
  },
};
</script>
